import Lottie from 'lottie-react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import styled from 'styled-components';
import {Button} from '@/components/Button';
import {ErrorLottie} from '@/components/Lottie';
import {Typography} from '@/components/Typography';
import {PaymentActionType} from '@/enums';
import {PaymentProcessParams} from '@/interface';
import {CHANNEL_TALK, paths} from '@/router';
import {
  FlexFullGrow, GrayRoundedBox, LinkText, PaddingBox, PageContent, SimpleListBox
} from '@/styled-components';
import {MEDIA_QUERIES, palette} from '@/styles';

export const Failure = ({transaction, type}: PaymentProcessParams) => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('message');
  const code = searchParams.get('code');
  const orderId = searchParams.get('orderId'); // 토스 단건결제 orderId
  const navigate = useNavigate();
  const onClick = () => {
    const pathname =
      type === PaymentActionType.method ? paths.mypage_pay : paths.pricing_root;

    navigate({pathname});
  };

  return (
    <Root>
      <Typography variant="bold24" color={palette.gray900}>
        {type === PaymentActionType.method
          ? '카드 정보를 변경하지 못했습니다'
          : '정상적으로 결제되지 않았습니다'}
      </Typography>
      <Typography variant="medium14" color={palette.gray600}>
        이용에 불편을 드려 죄송합니다
      </Typography>
      <ImageWrapper>
        <Lottie
          loop={false}
          animationData={ErrorLottie}
          style={{width: 140, height: 140}}
        />
      </ImageWrapper>
      <RoundedBox>
        <Typography variant="medium14" fontWeight={400}>
          <strong>실패 사유</strong> {decodeURIComponent(reason || '')}{' '}
          {!!code && `(${code})`}
        </Typography>
        {type !== PaymentActionType.method && (
          <Typography variant="medium14" fontWeight={400}>
            <strong>결제 번호</strong> {transaction}
          </Typography>
        )}
        {!!orderId && (
          <Typography variant="medium14" fontWeight={400}>
            <strong>주문 번호</strong> {orderId}
          </Typography>
        )}
      </RoundedBox>
      <PaddingBox top={8}>
        <SimpleListBox>
          <ul>
            <li>실패 사유를 확인하신 후 다시 시도해 주세요.</li>
            <li>
              계속해서 문제가 발생할 경우{' '}
              <LinkText href={CHANNEL_TALK} target="_blank">
                고객센터
              </LinkText>
              로 문의해 주세요.
            </li>
          </ul>
        </SimpleListBox>
      </PaddingBox>
      <Button
        size="mediumLarge"
        color="primary"
        variant="fill"
        fullWidth
        onClick={onClick}
      >
        {type === PaymentActionType.method ? '다시 변경하기' : '다시 결제 하기'}
      </Button>
    </Root>
  );
};

const Root = styled(PageContent)`
  align-items: center;
  ${MEDIA_QUERIES.exclude_mobile} {
    min-height: 482px;
  }
  min-height: 100%;
  gap: 16px;
`;

const ImageWrapper = styled(FlexFullGrow)`
  display: flex;
  align-items: center;
`;

const RoundedBox = styled(GrayRoundedBox)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;
  padding: 16px 12px;
  color: ${palette.gray800};
  width: 100%;
`;
